import { EMAIL_HINT, showEmailHint } from "@shared/email-format";

/**
 * EMAIL-FORMAT-1 (s236, D-236.38(3)) — the quiet line under an email box. It never blocks: the value saves as typed.
 * `allowWebsite` for the company card's "Email or website".
 */
export function EmailHint({ value, allowWebsite = false, className = "text-[12px] text-muted-foreground", testId }: {
  value: string | null | undefined;
  allowWebsite?: boolean;
  className?: string;
  testId?: string;
}) {
  if (!showEmailHint(value, allowWebsite)) return null;
  return (
    <p className={`mt-1 ${className}`} role="note" data-testid={testId ?? "email-hint"}>
      {EMAIL_HINT}
    </p>
  );
}
